import { cn } from '@rocco/utils/cn';
import { ARTICLE_HEADLINE_TYPE } from '../util/article-display-type';
import { RevampTitleReveal } from './RevampTitleReveal';

interface RevampHeaderProps {
    title: string;
    /** `light` = white, for the headline over the masthead's photograph. */
    tone?: 'ink' | 'light';
}

/**
 * Article revamp header: the headline alone, ranged left under the header's
 * monogram exactly where the product page sets its title — 60px under the
 * band, half a rem outside the gutter so the letters' side bearings sit on
 * it. The sponsor and the date have moved to the byline row beneath.
 */
export const RevampHeader = ({ title, tone = 'ink' }: RevampHeaderProps) => (
    <header className="w-full">
        <h1
            data-head-ink=""
            className={cn(
                // A shorter measure than the page: at 72px a line that ran
                // the full 1824 read as a banner rather than a headline.
                'm-0 w-full text-left max-md:mt-4 md:mt-[3.75rem] md:-ml-[0.5rem] md:max-w-[88rem]',
                ARTICLE_HEADLINE_TYPE,
                tone === 'light' && 'text-white',
            )}
        >
            <RevampTitleReveal text={title} />
        </h1>
    </header>
);
